export default "__VITE_ASSET__8d547866__"